// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./bg-shapes.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E5E7EB; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9FA6B2; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-3 {
  bottom: 0.75rem;
}
.left-0 {
  left: 0px;
}
.left-\\[-10px\\] {
  left: -10px;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[60px\\] {
  top: 60px;
}
.top-\\[7px\\] {
  top: 7px;
}
.z-50 {
  z-index: 50;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.m-auto {
  margin: auto;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-\\[-40px\\] {
  margin-left: -40px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[87vh\\] {
  height: 87vh;
}
.h-\\[calc\\(100vh-75px\\)\\] {
  height: calc(100vh - 75px);
}
.h-screen {
  height: 100vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-8 {
  width: 2rem;
}
.w-96 {
  width: 24rem;
}
.w-full {
  width: 100%;
}
.min-w-\\[450px\\] {
  min-width: 450px;
}
.min-w-\\[800px\\] {
  min-width: 800px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[230px\\] {
  max-width: 230px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[550px\\] {
  max-width: 550px;
}
.max-w-\\[732px\\] {
  max-width: 732px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-lg {
  max-width: 32rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes glow {

  0% {
    box-shadow: 0px 1px 10px 3px rgba(254,0,188,0.2);
  }

  40% {
    box-shadow: 0px 1px 11px 4px rgba(254,0,188,0.4);
  }

  80% {
    box-shadow: 0px 1px 12px 5px rgba(254,0,188,0.6);
  }

  100% {
    box-shadow: 0px 1px 11px 4px rgba(254,0,188,0.8);
  }
}
.animate-glow {
  animation: glow 1s ease-in-out infinite alternate;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-4 {
  gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.overflow-auto {
  overflow: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-b-8 {
  border-bottom-width: 8px;
}
.border-r-8 {
  border-right-width: 8px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-8 {
  border-top-width: 8px;
}
.border-none {
  border-style: none;
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(210 214 220 / var(--tw-border-opacity));
}
.border-kog-100 {
  --tw-border-opacity: 1;
  border-color: rgb(50 26 72 / var(--tw-border-opacity));
}
.border-kog-300 {
  --tw-border-opacity: 1;
  border-color: rgb(71 39 101 / var(--tw-border-opacity));
}
.border-kog-400 {
  --tw-border-opacity: 1;
  border-color: rgb(137 15 131 / var(--tw-border-opacity));
}
.border-kog-500 {
  --tw-border-opacity: 1;
  border-color: rgb(159 20 152 / var(--tw-border-opacity));
}
.border-kog-600 {
  --tw-border-opacity: 1;
  border-color: rgb(144 36 156 / var(--tw-border-opacity));
}
.border-kog-700 {
  --tw-border-opacity: 1;
  border-color: rgb(176 46 191 / var(--tw-border-opacity));
}
.border-kog-800 {
  --tw-border-opacity: 1;
  border-color: rgb(218 24 208 / var(--tw-border-opacity));
}
.border-kog-900 {
  --tw-border-opacity: 1;
  border-color: rgb(241 26 230 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
.border-b-transparent {
  border-bottom-color: transparent;
}
.border-r-kog-900 {
  --tw-border-opacity: 1;
  border-right-color: rgb(241 26 230 / var(--tw-border-opacity));
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-opacity-30 {
  --tw-border-opacity: 0.3;
}
.border-opacity-40 {
  --tw-border-opacity: 0.4;
}
.border-opacity-50 {
  --tw-border-opacity: 0.5;
}
.border-opacity-80 {
  --tw-border-opacity: 0.8;
}
.bg-black-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 18 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(210 214 220 / var(--tw-bg-opacity));
}
.bg-kog-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(50 26 72 / var(--tw-bg-opacity));
}
.bg-kog-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(44 23 64 / var(--tw-bg-opacity));
}
.bg-kog-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 39 101 / var(--tw-bg-opacity));
}
.bg-kog-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(137 15 131 / var(--tw-bg-opacity));
}
.bg-kog-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 20 152 / var(--tw-bg-opacity));
}
.bg-kog-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(218 24 208 / var(--tw-bg-opacity));
}
.bg-kog-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 26 230 / var(--tw-bg-opacity));
}
.bg-kog-999 {
  background-color: rgba(28,14,41,0.5);
}
.bg-purple-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-100 {
  --tw-bg-opacity: 1;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-blue-900 {
  --tw-gradient-from: #1e3a8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-300 {
  --tw-gradient-from: #D2D6DC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(210 214 220 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-900 {
  --tw-gradient-from: #14532d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 83 45 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kog-300 {
  --tw-gradient-from: #472765 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 39 101 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kog-50 {
  --tw-gradient-from: rgba(28,14,41,0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(28, 14, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kog-700 {
  --tw-gradient-from: #b02ebf var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(176 46 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kog-800 {
  --tw-gradient-from: #da18d0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(218 24 208 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kog-900 {
  --tw-gradient-from: #f11ae6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 26 230 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kog-950 {
  --tw-gradient-from: rgba(250, 110, 242,0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(250, 110, 242, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-900 {
  --tw-gradient-from: #7c2d12 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 45 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blue-400 {
  --tw-gradient-to: #60a5fa var(--tw-gradient-to-position);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-green-500 {
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-green-600 {
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.to-kog-400 {
  --tw-gradient-to: #890f83 var(--tw-gradient-to-position);
}
.to-kog-800 {
  --tw-gradient-to: #da18d0 var(--tw-gradient-to-position);
}
.to-kog-900 {
  --tw-gradient-to: #f11ae6 var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-yellow-500 {
  --tw-gradient-to: #eab308 var(--tw-gradient-to-position);
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-\\[60px\\] {
  padding-top: 60px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.font-thin {
  font-weight: 100;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(210 214 220 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.text-kog-100 {
  --tw-text-opacity: 1;
  color: rgb(50 26 72 / var(--tw-text-opacity));
}
.text-kog-300 {
  --tw-text-opacity: 1;
  color: rgb(71 39 101 / var(--tw-text-opacity));
}
.text-kog-900 {
  --tw-text-opacity: 1;
  color: rgb(241 26 230 / var(--tw-text-opacity));
}
.text-kog-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow-\\[0px_0px_10px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 0px 0px 10px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 0px 0px 10px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_10px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0px 0px 10px 10px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0px 0px 10px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_10px_1px_rgba\\(239\\2c 26\\2c 229\\2c 0\\.5\\)\\] {
  --tw-shadow: 0px 0px 10px 1px rgba(239,26,229,0.5);
  --tw-shadow-colored: 0px 0px 10px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_10px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0px 0px 10px 2px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 0px 10px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_10px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\] {
  --tw-shadow: 0px 0px 10px 5px rgba(0,0,0,0.4);
  --tw-shadow-colored: 0px 0px 10px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_10px_5px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.3\\)\\] {
  --tw-shadow: 0px 0px 10px 5px rgba(255,255,255,0.3);
  --tw-shadow-colored: 0px 0px 10px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_15px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0px 0px 15px 5px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 0px 15px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_4px_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0px 0px 4px 1px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0px 0px 4px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_5px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0px 0px 5px 2px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 0px 5px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_1px_10px_3px_rgba\\(254\\2c 0\\2c 188\\2c 0\\.2\\)\\] {
  --tw-shadow: 0px 1px 10px 3px rgba(254,0,188,0.2);
  --tw-shadow-colored: 0px 1px 10px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_7px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0px 2px 7px 2px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 2px 7px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_6px_10px_1px_rgba\\(241\\2c 26\\2c 230\\2c 0\\.2\\)\\] {
  --tw-shadow: 0px 6px 10px 1px rgba(241,26,230,0.2);
  --tw-shadow-colored: 0px 6px 10px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0px_0px_10px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: inset 0px 0px 10px 5px rgba(0,0,0,0.3);
  --tw-shadow-colored: inset 0px 0px 10px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0px_0px_10px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\] {
  --tw-shadow: inset 0px 0px 10px 5px rgba(0,0,0,0.4);
  --tw-shadow-colored: inset 0px 0px 10px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0px_0px_5px_5px_rgba\\(241\\2c 26\\2c 230\\2c 0\\.1\\)\\] {
  --tw-shadow: inset 0px 0px 5px 5px rgba(241,26,230,0.1);
  --tw-shadow-colored: inset 0px 0px 5px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0px_0px_5px_5px_rgba\\(241\\2c 26\\2c 230\\2c 0\\.3\\)\\] {
  --tw-shadow: inset 0px 0px 5px 5px rgba(241,26,230,0.3);
  --tw-shadow-colored: inset 0px 0px 5px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-kog-900 {
  --tw-shadow-color: #f11ae6;
  --tw-shadow: var(--tw-shadow-colored);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[4px\\] {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[text-shadow\\:_0_5px_10px_rgb\\(0_0_0_\\/_60\\%\\)\\] {
  text-shadow: 0 5px 10px rgb(0 0 0 / 60%);
}

body {
  height: 100%;
  overflow-x: hidden;
  background-attachment: fixed;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}

body:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}

body {
  font-family: 'Chakra Petch', 'Arial', 'Helvetica', sans-serif;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(-45deg, #5a1b6e, #5a1b6e, #9c0056, #5a1b6e, #5a1b6e); 
  /* Gradient background */
  background-size: cover, 400% 400%;
  /* Cover for image, animate for gradient */
  animation: gradient 70s ease infinite;
  height: 100vh;
  margin: 0;
  padding: 0;
}

/* Wallet connected background */
.wallet-connected body {
  animation: none; /* This removes the gradient animation */
background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(-45deg, #551768 0%, #5a1b6e 40%, #920050 60%, #5a1b6e 100%) !important;
background-size: cover, 300% 300% !important;
background-repeat: no-repeat, no-repeat;
background-attachment: fixed, local;
}

.dark body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(150deg,rgb(39,20,56) 35%,rgb(112,0,62) 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: center center, 0 0;
  background-size: cover, 100% 100%;
  background-attachment: fixed, local; /* Fix the image and allow the gradient to animate */
 
}

@keyframes gradients {
  0% {
    background-position: center center, 0 0; /* Starting position with mostly #5a1b6e */
  }
  50% {
    background-position: center center, 50% 50%; /* Gradient moves towards the middle */
  }
  100% {
    background-position: center center, 0 0; /* Gradient goes back to the starting point */
  }
}



/* 
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
} */


.task-item {
  margin-bottom: 0.5rem;
}


.react-tabs__tab {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  cursor: pointer;
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(210 214 220 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  transition: background-color 0.3s, color 0.3s;
}

.react-tabs__tab-list {
  border-bottom: none !important;
}

.react-tabs__tab--selected {
  border-radius: 5px !important;
}

.typewriter {
  display: inline-block;
}

.cursor {
  display: inline-block;
  margin-left: 2px;
  width: 1ch;
  background: transparent;
}

.blink {
  animation: blink-animation 0.7s steps(2) infinite;
}

@keyframes blink-animation {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@keyframes progressBar {
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
}

.animate-progress-bar {
  animation: progressBar 4s linear forwards;
}

/* Customize the tooltip box */
.introjs-tooltip {
  

  background: rgb(185,54,227);
background: linear-gradient(5deg, #853ec7  0%, rgb(73, 1, 112) 81%);
  
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.4) !important; /* Shadow effect */
  color: white; /* Text color */
  font-size: 16px; /* Font size */
  font-family: 'Chakra Petch', 'Arial', 'Helvetica', sans-serif !important;
}

/* Customize the arrow that points to the highlighted element */
.introjs-tooltip .introjs-arrow {
  border-bottom-color:#652686 !important;
  border-right-color:#652686 !important;
  
}

/* Customize the tooltip header */
.introjs-tooltip-title {
  font-size: 18px; /* Header font size */
  font-weight: bold;
  color: #fff;
}

/* Customize the Next, Previous, Done buttons */
.introjs-button {
  background-color: #2c1740 !important;
  color: white !important; 
  border: 1px solid #c7379c !important;
  border-radius: 50px !important; 
  padding: 8px 16px; 
  font-size: 14px; 
  cursor: pointer;
  text-shadow: none !important;
  
}

.introjs-tooltipbuttons {
  border-top: #c7379c !important;
}

.introjs-bullets ul li a.active {
  background-color: #c7379c !important; 
  background: #c7379c !important;
}

.introjs-button:hover {
  background-color: #45a049;
  
}



/* Customize the step numbers (if enabled) */
.introjs-helperNumberLayer {
  background-color: #ff9800; 
  color: white; 
  border-radius: 50%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

/* Customize the tooltip close button */
.introjs-skipbutton {
  
  color: white !important;
}

/* Change tooltip position for specific steps */
.introjs-tooltiptext {
  text-align: left; /* Align the text */
  font-family: 'Chakra Petch', 'Arial', 'Helvetica', sans-serif !important;
  padding:20px 10px !important; /* Add padding */
  text-align: center;
}

.introjs-overlay{
  background-color: rgba(0, 0, 0, 0.9) !important;
  opacity: 0.2 !important;
}

.introjs-helperLayer{
  border: 1px solid #ff5fdc !important;
}

.introjs-arrow.right{
  border-right-color: #ff5fdc !important;
  
}

.tooltip {
  opacity: 0;
  transform: translateX(0);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}

button:hover + .tooltip {
  opacity: 1;
  transform: translateX(-10px); /* Slide left when hovering */
}

.tooltip-arrow {
  position: absolute;
  right: 0; /* Position the arrow to the right of the tooltip */
  top: 50%;
  transform: translateY(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent transparent #f11ae6; /* Background color of the tooltip */
}

@keyframes plus {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(180deg);
  }
}

.hover\\:animate-plus:hover {
  animation: plus 1s ease-in-out;
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-kog-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(137 15 131 / var(--tw-bg-opacity));
}

.hover\\:bg-kog-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(159 20 152 / var(--tw-bg-opacity));
}

.hover\\:bg-kog-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(218 24 208 / var(--tw-bg-opacity));
}

.hover\\:bg-kog-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 26 230 / var(--tw-bg-opacity));
}

.hover\\:from-kog-300:hover {
  --tw-gradient-from: #472765 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 39 101 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kog-500:hover {
  --tw-gradient-from: #9f1498 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(159 20 152 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kog-900:hover {
  --tw-gradient-from: #f11ae6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 26 230 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-kog-500:hover {
  --tw-gradient-to: #9f1498 var(--tw-gradient-to-position);
}

.hover\\:to-kog-900:hover {
  --tw-gradient-to: #f11ae6 var(--tw-gradient-to-position);
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}

.hover\\:text-kog-900:hover {
  --tw-text-opacity: 1;
  color: rgb(241 26 230 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:shadow-\\[0px_0px_10px_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]:hover {
  --tw-shadow: 0px 0px 10px 1px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 0px 10px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0px_0px_10px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]:hover {
  --tw-shadow: 0px 0px 10px 5px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 0px 10px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:border-none:is(.dark *) {
  border-style: none;
}

.dark\\:border-kog-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(137 15 131 / var(--tw-border-opacity));
}

.dark\\:border-kog-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(218 24 208 / var(--tw-border-opacity));
}

.dark\\:border-kog-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(241 26 230 / var(--tw-border-opacity));
}

.dark\\:border-opacity-30:is(.dark *) {
  --tw-border-opacity: 0.3;
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}

.dark\\:bg-kog-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(44 23 64 / var(--tw-bg-opacity));
}

.dark\\:bg-kog-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(71 39 101 / var(--tw-bg-opacity));
}

.dark\\:bg-kog-999:is(.dark *) {
  background-color: rgba(28,14,41,0.5);
}

.dark\\:bg-opacity-10:is(.dark *) {
  --tw-bg-opacity: 0.1;
}

.dark\\:from-kog-300:is(.dark *) {
  --tw-gradient-from: #472765 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 39 101 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-kog-400:is(.dark *) {
  --tw-gradient-from: #890f83 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(137 15 131 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:to-blue-500:is(.dark *) {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}

.dark\\:to-green-500:is(.dark *) {
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}

.dark\\:to-kog-100:is(.dark *) {
  --tw-gradient-to: #321a48 var(--tw-gradient-to-position);
}

.dark\\:to-kog-50:is(.dark *) {
  --tw-gradient-to: rgba(28,14,41,0.5) var(--tw-gradient-to-position);
}

.dark\\:to-orange-500:is(.dark *) {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

.dark\\:text-pink-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity));
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark\\:shadow-\\[0px_0px_10px_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.7\\)\\]:is(.dark *) {
  --tw-shadow: 0px 0px 10px 1px rgba(0,0,0,0.7);
  --tw-shadow-colored: 0px 0px 10px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0px_0px_10px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]:is(.dark *) {
  --tw-shadow: 0px 0px 10px 5px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0px 0px 10px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0px_6px_10px_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\]:is(.dark *) {
  --tw-shadow: 0px 6px 10px 1px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0px 6px 10px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[inset_0px_0px_5px_5px_rgba\\(241\\2c 26\\2c 230\\2c 0\\.1\\)\\]:is(.dark *) {
  --tw-shadow: inset 0px 0px 5px 5px rgba(241,26,230,0.1);
  --tw-shadow-colored: inset 0px 0px 5px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:hover\\:from-kog-300:hover:is(.dark *) {
  --tw-gradient-from: #472765 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 39 101 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:hover\\:to-kog-900:hover:is(.dark *) {
  --tw-gradient-to: #f11ae6 var(--tw-gradient-to-position);
}

@media (min-width: 640px) {

  .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:mr-4 {
    margin-right: 1rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px) {

  .md\\:top-3 {
    top: 0.75rem;
  }

  .md\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:ml-\\[-210px\\] {
    margin-left: -210px;
  }

  .md\\:max-w-\\[350px\\] {
    max-width: 350px;
  }

  .md\\:max-w-\\[800px\\] {
    max-width: 800px;
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
}

@media (min-width: 1024px) {

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:order-3 {
    order: 3;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-4\\/5 {
    width: 80%;
  }

  .lg\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-right {
    text-align: right;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAKjB;EAAA,YAAuF;EAAvF,kBAAuF;EAAvF,4BAAuF;EAAvF,gBAAuF;EAAvF,oBAAuF;EAAvF;AAAuF;;AAAvF;EAAA,oBAAuF;EAAvF;AAAuF;;AADzF;EAEE,6DAA6D;EAC7D,+HAA8G;EAC9G,wBAAwB;EACxB,iCAAiC;EACjC,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,eAAe,EAAE,wCAAwC;AAC3D,iJAAgI;AAChI,4CAA4C;AAC5C,uCAAuC;AACvC,mCAAmC;AACnC;;AAEA;EACE,uHAAsG;EACtG,uCAAuC;EACvC,uCAAuC;EACvC,iCAAiC;EACjC,mCAAmC,EAAE,oDAAoD;;AAE3F;;AAEA;EACE;IACE,uCAAuC,EAAE,0CAA0C;EACrF;EACA;IACE,2CAA2C,EAAE,sCAAsC;EACrF;EACA;IACE,uCAAuC,EAAE,6CAA6C;EACxF;AACF;;;;AAIA;;;;;;;;;;;;;GAaG;;;AAGH;EACE,qBAAqB;AACvB;;;AAIE;EAAA,oBAAgG;EAAhG,qBAAgG;EAAhG,eAAgG;EAAhG,qBAAgG;EAAhG,iBAAgG;EAAhG,sBAAgG;EAAhG,yDAAgG;EAAhG,kBAAgG;EAAhG,yDAAgG;EAAhG,kBAAgG;EAAhG,mBAAgG;EAAhG,mBAAgG;EAAhG,sBAAgG;EAAhG,kBAAgG;EAChG;AADgG;;AAIlG;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;;;EAGE,2BAA2B;AAC7B,mEAAmE;;EAEjE,mBAAmB,EAAE,oBAAoB;EACzC,oDAAoD,EAAE,kBAAkB;EACxE,YAAY,EAAE,eAAe;EAC7B,eAAe,EAAE,cAAc;EAC/B,wEAAwE;AAC1E;;AAEA,+DAA+D;AAC/D;EACE,sCAAsC;EACtC,qCAAqC;;AAEvC;;AAEA,iCAAiC;AACjC;EACE,eAAe,EAAE,qBAAqB;EACtC,iBAAiB;EACjB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,4BAA4B;;AAE9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;;AAE3B;;;;AAIA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;;EAEE,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB,EAAE,mBAAmB;EACrC,wEAAwE;EACxE,4BAA4B,EAAE,gBAAgB;EAC9C,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;;AAExC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,4BAA4B,EAAE,6BAA6B;AAC7D;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,mDAAmD;EAC7D,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD,EAAE,oCAAoC;AACjG;;AAlPA;;EAAA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;AAAA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,4DAmPA;EAnPA,mEAmPA;EAnPA;AAmPA;;AAnPA;EAAA,4DAmPA;EAnPA,oEAmPA;EAnPA;AAmPA;;AAnPA;EAAA,4DAmPA;EAnPA,oEAmPA;EAnPA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA,oBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,oBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,oBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,6CAmPA;EAnPA,4DAmPA;EAnPA;AAmPA;;AAnPA;EAAA,6CAmPA;EAnPA,4DAmPA;EAnPA;AAmPA;;AAnPA;EAAA,6EAmPA;EAnPA,iGAmPA;EAnPA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA,sBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,sBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,sBAmPA;EAnPA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,kBAmPA;EAnPA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA,4DAmPA;EAnPA,mEAmPA;EAnPA;AAmPA;;AAnPA;EAAA,4DAmPA;EAnPA,oEAmPA;EAnPA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;EAAA,oBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,oBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,oBAmPA;EAnPA;AAmPA;;AAnPA;EAAA,6CAmPA;EAnPA,4DAmPA;EAnPA;AAmPA;;AAnPA;EAAA,6CAmPA;EAnPA,4DAmPA;EAnPA;AAmPA;;AAnPA;EAAA,6CAmPA;EAnPA,4DAmPA;EAnPA;AAmPA;;AAnPA;EAAA,uDAmPA;EAnPA,iEAmPA;EAnPA;AAmPA;;AAnPA;EAAA,4DAmPA;EAnPA,mEAmPA;EAnPA;AAmPA;;AAnPA;EAAA;AAmPA;;AAnPA;;EAAA;IAAA,iBAmPA;IAnPA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA,uBAmPA;IAnPA,oDAmPA;IAnPA;EAmPA;;EAnPA;IAAA,kBAmPA;IAnPA;EAmPA;;EAnPA;IAAA,mBAmPA;IAnPA;EAmPA;;EAnPA;IAAA,eAmPA;IAnPA;EAmPA;;EAnPA;IAAA,kBAmPA;IAnPA;EAmPA;AAAA;;AAnPA;;EAAA;IAAA;EAmPA;;EAnPA;IAAA,iBAmPA;IAnPA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA,kBAmPA;IAnPA;EAmPA;AAAA;;AAnPA;;EAAA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;;EAnPA;IAAA;EAmPA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import url('https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;700&display=swap');\n\nbody {\n  @apply h-full overflow-x-hidden dark:text-slate-300 text-slate-300 font-normal bg-fixed;\n  font-family: 'Chakra Petch', 'Arial', 'Helvetica', sans-serif;\n  background-image: url('./bg-shapes.png'), linear-gradient(-45deg, #5a1b6e, #5a1b6e, #9c0056, #5a1b6e, #5a1b6e); \n  /* Gradient background */\n  background-size: cover, 400% 400%;\n  /* Cover for image, animate for gradient */\n  animation: gradient 70s ease infinite;\n  height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\n/* Wallet connected background */\n.wallet-connected body {\n  animation: none; /* This removes the gradient animation */\nbackground-image: url('./bg-shapes.png'), linear-gradient(-45deg, #551768 0%, #5a1b6e 40%, #920050 60%, #5a1b6e 100%) !important;\nbackground-size: cover, 300% 300% !important;\nbackground-repeat: no-repeat, no-repeat;\nbackground-attachment: fixed, local;\n}\n\n.dark body {\n  background-image: url('./bg-shapes.png'), linear-gradient(150deg,rgb(39,20,56) 35%,rgb(112,0,62) 100%);\n  background-repeat: no-repeat, no-repeat;\n  background-position: center center, 0 0;\n  background-size: cover, 100% 100%;\n  background-attachment: fixed, local; /* Fix the image and allow the gradient to animate */\n \n}\n\n@keyframes gradients {\n  0% {\n    background-position: center center, 0 0; /* Starting position with mostly #5a1b6e */\n  }\n  50% {\n    background-position: center center, 50% 50%; /* Gradient moves towards the middle */\n  }\n  100% {\n    background-position: center center, 0 0; /* Gradient goes back to the starting point */\n  }\n}\n\n\n\n/* \n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n} */\n\n\n.task-item {\n  margin-bottom: 0.5rem;\n}\n\n\n.react-tabs__tab {\n  @apply px-4 py-2 mx-1 rounded-full text-center border border-gray-300 bg-gray-200 cursor-pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.react-tabs__tab-list {\n  border-bottom: none !important;\n}\n\n.react-tabs__tab--selected {\n  border-radius: 5px !important;\n}\n\n.typewriter {\n  display: inline-block;\n}\n\n.cursor {\n  display: inline-block;\n  margin-left: 2px;\n  width: 1ch;\n  background: transparent;\n}\n\n.blink {\n  animation: blink-animation 0.7s steps(2) infinite;\n}\n\n@keyframes blink-animation {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n}\n\n@keyframes progressBar {\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n}\n\n.animate-progress-bar {\n  animation: progressBar 4s linear forwards;\n}\n\n/* Customize the tooltip box */\n.introjs-tooltip {\n  \n\n  background: rgb(185,54,227);\nbackground: linear-gradient(5deg, #853ec7  0%, rgb(73, 1, 112) 81%);\n  \n  border-radius: 10px; /* Rounded corners */\n  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.4) !important; /* Shadow effect */\n  color: white; /* Text color */\n  font-size: 16px; /* Font size */\n  font-family: 'Chakra Petch', 'Arial', 'Helvetica', sans-serif !important;\n}\n\n/* Customize the arrow that points to the highlighted element */\n.introjs-tooltip .introjs-arrow {\n  border-bottom-color:#652686 !important;\n  border-right-color:#652686 !important;\n  \n}\n\n/* Customize the tooltip header */\n.introjs-tooltip-title {\n  font-size: 18px; /* Header font size */\n  font-weight: bold;\n  color: #fff;\n}\n\n/* Customize the Next, Previous, Done buttons */\n.introjs-button {\n  background-color: #2c1740 !important;\n  color: white !important; \n  border: 1px solid #c7379c !important;\n  border-radius: 50px !important; \n  padding: 8px 16px; \n  font-size: 14px; \n  cursor: pointer;\n  text-shadow: none !important;\n  \n}\n\n.introjs-tooltipbuttons {\n  border-top: #c7379c !important;\n}\n\n.introjs-bullets ul li a.active {\n  background-color: #c7379c !important; \n  background: #c7379c !important;\n}\n\n.introjs-button:hover {\n  background-color: #45a049;\n  \n}\n\n\n\n/* Customize the step numbers (if enabled) */\n.introjs-helperNumberLayer {\n  background-color: #ff9800; \n  color: white; \n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Customize the tooltip close button */\n.introjs-skipbutton {\n  \n  color: white !important;\n}\n\n/* Change tooltip position for specific steps */\n.introjs-tooltiptext {\n  text-align: left; /* Align the text */\n  font-family: 'Chakra Petch', 'Arial', 'Helvetica', sans-serif !important;\n  padding:20px 10px !important; /* Add padding */\n  text-align: center;\n}\n\n.introjs-overlay{\n  background-color: rgba(0, 0, 0, 0.9) !important;\n  opacity: 0.2 !important;\n}\n\n.introjs-helperLayer{\n  border: 1px solid #ff5fdc !important;\n}\n\n.introjs-arrow.right{\n  border-right-color: #ff5fdc !important;\n  \n}\n\n.tooltip {\n  opacity: 0;\n  transform: translateX(0);\n  transition: opacity 0.3s ease-out, transform 0.3s ease-out;\n}\n\nbutton:hover + .tooltip {\n  opacity: 1;\n  transform: translateX(-10px); /* Slide left when hovering */\n}\n\n.tooltip-arrow {\n  position: absolute;\n  right: 0; /* Position the arrow to the right of the tooltip */\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 8px;\n  border-style: solid;\n  border-color: transparent transparent transparent #f11ae6; /* Background color of the tooltip */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
